import React from 'react';

/**
 * Ticking wall clock for the POS top bar. Returns a localized `HH:MM:SS`
 * string, updated every second. Logic-only so the top bar stays render-only.
 */
export const useClock = (): string => {
    const [now, setNow] = React.useState(() => new Date());

    React.useEffect(() => {
        const id = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(id);
    }, []);

    return now.toLocaleTimeString('ka-GE', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
};
